// Game configuration constants
export const WORLD_WIDTH = 400;
export const WORLD_HEIGHT = 600;
// Basket configuration
export const BASKET_WIDTH = 80;
export const BASKET_HEIGHT = 50;
export const BASKET_Y = WORLD_HEIGHT - 80;
export const BASKET_SPEED = 8;
// Star configuration
export const STAR_SIZE = 30;
export const STAR_FALL_SPEED_MIN = 2;
export const STAR_FALL_SPEED_MAX = 4;
export const SPAWN_INTERVAL = 800; // ms between star spawns
export const STAR_SPAWN_PADDING = 40;
// Color palette
export const COLORS = {
  SKY_BLUE: 0x87CEEB,
  STAR_YELLOW: 0xFFD700,
  BASKET_BROWN: 0x8B4513,
  BASKET_DARK: 0x5D3A1A,
  STAR_GLOW: 0xFFF8DC,
} as const;
// Touch/Input
export const TOUCH_SENSITIVITY = 1.5;
// Best score persistence
export const BEST_SCORE_STORAGE_KEY = 'catch-the-star-best-score';
// Particle feedback
export const CATCH_PARTICLE_COUNT = 5;
export const PARTICLE_LIFETIME_MS = 400;
// Catch sound (procedural Web Audio, no external file needed)
export const CATCH_SOUND_ENABLED = true;